// Central Turkish content for the entire Epersonel website.
// All public-facing copy lives here. Never translate to English.

export const BRAND = {
  name: "Epersonel",
  logoAlt: "Epersonel — Dijital Satış Operasyonu Partneri",
  logo: "/3(5).png",
  logoLight: "/2(4).png",
  slogan: "Dijital Satışın Tüm Süreci Tek Yerde.",
  slogans: {
    supporting: "Kuruyoruz. Yönetiyoruz. Ulaştırıyoruz.",
    bold: "Biz dışarıda duran değil, içeriden yapan firmayız.",
    positioning:
      "Üye İşyerleri için uçtan uca dijital satış ve operasyon çözümleri.",
  },
  contact: {
    phone: "0530 133 22 05",
    phoneRaw: "905301332205",
    email: "epersonel@outlook.com",
    location: "İstanbul",
    hours: "Haftanın her günü 10.00–22.00",
    instagram: "epersonel",
    linkedin: "epersonel",
    whatsappMessage:
      "Merhaba, Epersonel hizmetleri hakkında bilgi almak istiyorum. Üye İşyerimin adı:",
  },
};

export const NAV = [
  { label: "Ana Sayfa", href: "/" },
  { label: "Hizmetlerimiz", href: "/hizmetlerimiz", hasDropdown: true },
  { label: "Nasıl Çalışır?", href: "/nasil-calisir" },
  { label: "Referanslarımız", href: "/referanslarimiz" },
  { label: "Hakkımızda", href: "/hakkimizda" },
  { label: "İletişim", href: "/iletisim" },
];

export const SERVICES = [
  {
    slug: "pazaryeri-kurulum-yonetimi",
    title: "Pazaryeri Kurulum ve Yönetimi",
    seoTitle: "Pazaryeri Kurulum ve Yönetimi | Epersonel",
    seoDescription:
      "Pazaryeri mağaza başvurusundan ürün girişlerine, kampanyalardan günlük operasyon takibine kadar işyerinizin pazaryeri süreçlerini uçtan uca yönetiyoruz.",
    short:
      "Mağaza başvurusundan ürün girişlerine, kampanyalardan günlük operasyon takibine kadar pazaryeri süreçlerinizi yönetiyoruz.",
    ctaLabel: "Detayları İncele",
    heading: "Pazaryeri Mağazanızı Kuruyor, Günlük Operasyonunuzu Yönetiyoruz.",
    intro:
      "Mağaza başvurusundan binlerce ürünün hazırlanmasına, fiyat ve stok güncellemelerinden kampanya ve sipariş takibine kadar zaman alan süreçleri Epersonel'e bırakın.",
    scope: [
      "İşyeri için uygun pazaryerlerinin belirlenmesi",
      "Mağaza başvurusu",
      "Gerekli evrak süreçlerinin takibi",
      "Mağaza açılışı",
      "Ürün veya menü listesinin hazırlanması",
      "Ürün adı ve açıklamalarının düzenlenmesi",
      "Kategori, marka, barkod, gramaj ve KDV bilgilerinin hazırlanması",
      "Ürün ve menü görsellerinin düzenlenmesi",
      "Seçenek ve ek ürün gruplarının oluşturulması",
      "Fiyat ve stok kontrolü",
      "Kampanya ve reklam takibi",
      "Sipariş operasyonu",
      "İptal ve iade takibi",
      "Fatura süreçlerinin takibi",
      "Mağaza performansının incelenmesi",
    ],
    closingHeading: "Pazaryerlerinde Satışa Başlamaya Hazır mısınız?",
    closingCta: "Pazaryeri Analizi İste",
  },
  {
    slug: "uye-isyerine-ozel-siparis-sistemi",
    title: "İşyerinize Özel Sipariş Sistemi",
    seoTitle: "Web ve Mobil Sipariş Sistemi | Epersonel",
    seoDescription:
      "İşyerinizin adı, logosu ve alan adıyla çalışan web sipariş sistemi ile App Store ve Google Play'de yayımlanan mobil uygulama.",
    short:
      "Kendi internet siteniz ve kendi mobil uygulamanız üzerinden müşterilerinizden doğrudan sipariş alın.",
    ctaLabel: "Sistemi İncele",
    eyebrow: "KENDİ MARKANIZ, KENDİ SİPARİŞ KANALINIZ",
    heading:
      "Müşterileriniz İnternet Sitenizden veya Mobil Uygulamanızdan Doğrudan Sipariş Versin.",
    intro:
      "İşyerinizin adı, logosu, renkleri ve alan adıyla çalışan web sipariş sisteminizi ve mobil uygulamanızı hazırlıyoruz. Ürünlerinizi ve fiyatlarınızı yönetin, kampanyalar oluşturun, siparişlerinizi takip edin ve müşterilerinize doğrudan ulaşın.",
    mainStatement:
      "Kendi internet siteniz, kendi mobil uygulamanız, kendi müşterileriniz.",
    secondaryStatement:
      "Web sitesi, mobil uygulama, ödeme, entegrasyon ve teslimat tek sistemde.",
    appStoreNote:
      "Her mobil uygulama, işyerinin kendi adı, logosu ve kurumsal kimliğiyle ayrı ayrı hazırlanır; App Store ve Google Play'de işyerinin kendi markasıyla yayımlanır.",
    features: [
      "İşyerine özel alan adı",
      "Kurumsal kimliğe özel tasarım",
      "Web üzerinden sipariş",
      "App Store mobil uygulaması",
      "Google Play mobil uygulaması",
      "Online ödeme",
      "Kapıda nakit ödeme",
      "Kapıda kartla ödeme",
      "Adrese teslimat",
      "Gel-al",
      "Teslimat bölgesi belirleme",
      "Minimum sepet tutarı",
      "Teslimat ücreti belirleme",
      "Kampanya ve indirim kuponları",
      "Anlık sipariş bildirimleri",
      "Sipariş durumu takibi",
      "İleri tarihli sipariş",
      "Müşteri üyeliği",
      "Müşteri sipariş geçmişi",
      "Satış raporları",
      "Fiyat ve stok entegrasyonu",
      "Kurye çağırma",
      "Ürün, fiyat ve stok yönetimi",
    ],
    closingCta: "Demo Talep Et",
    secondaryCta: "İşyerinize Özel Teklif Alın",
  },
  {
    slug: "kurye-cozumu",
    title: "Kurye Çözümü",
    seoTitle: "Üye İşyerlerine Özel Kurye Çözümü | Epersonel",
    seoDescription:
      "Kendi kuryesi bulunmayan veya teslimat kapasitesini artırmak isteyen işyerlerine anlık yönlendirme ve harita üzerinden takip sunan kurye çözümü.",
    short:
      "Kendi kuryesi bulunmayan veya teslimat kapasitesini artırmak isteyen Üye İşyerlerine özel kurye çözümü.",
    ctaLabel: "Kurye Çözümünü İncele",
    eyebrow: "EPERSONEL KURYE ÇÖZÜMÜ",
    heading:
      "Sipariş Hangi Kanaldan Gelirse Gelsin, Teslimatını Gerçekleştirin.",
    intro:
      "Kendi kuryesi bulunmayan veya teslimat kapasitesini artırmak isteyen işyerleri için özel kurye çözümü sunuyoruz. İnternet sitenizden, mobil uygulamanızdan veya pazaryerlerinden aldığınız siparişler için kurye yönlendirin; teslimat sürecini harita üzerinden takip edin.",
    highlight: "Kuryeniz olmadığı için sipariş kaybetmeyin.",
    process: [
      "Sipariş alınır.",
      "İşyeri siparişi hazırlar.",
      "Kurye yönlendirilir.",
      "Teslimat harita üzerinden takip edilir.",
      "Sipariş müşteriye teslim edilir.",
    ],
    features: [
      "Epersonel tarafından sağlanan kurye operasyonu",
      "Farklı pazaryeri siparişlerinde kullanım",
      "Web ve mobil uygulama siparişlerinde kullanım",
      "Anlık kurye yönlendirme",
      "Harita üzerinden canlı takip",
      "Nakit ödeme alabilme",
      "Kartla ödeme alabilme",
      "İşyerine özel teslimat mesafesi",
      "İşyerine özel çalışma saatleri",
      "İhtiyaca göre operasyon planlaması",
      "Türkiye genelinde operasyonel uygunluğa göre hizmet",
    ],
    disclaimer:
      "Hizmet kapsamı, teslimat bölgesi, çalışma saatleri ve ücretlendirme işyerinin konumuna ve operasyon ihtiyacına göre belirlenir.",
    closingCta: "Kurye Çözümü Talep Et",
    secondaryCta: "İşyerinize Özel Teklif Alın",
  },
  {
    slug: "fiyat-ve-stok-entegrasyonu",
    title: "Fiyat ve Stok Entegrasyonu",
    seoTitle: "Fiyat ve Stok Entegrasyonu | Epersonel",
    seoDescription:
      "İşyerinizin kasa veya stok sistemini satış kanallarıyla eşleştirin; manuel iş yükünü ve stok kaynaklı sorunları azaltın.",
    short:
      "Fiyat ve stok bilgileriniz satış kanallarında güncel kalsın; manuel iş yükü ve stok kaynaklı sorunlar azalsın.",
    ctaLabel: "Entegrasyonu İncele",
    heading: "Fiyat ve Stoklarınız Satış Kanallarında Güncel Kalsın.",
    intro:
      "Manuel güncellemelerin oluşturduğu iş yükünü azaltın. Teknik uygunluğa göre işyerinizin kasa veya stok sistemini satış kanallarıyla eşleştirin.",
    scope: [
      "Fiyatların daha düzenli güncellenmesi",
      "Stokta olmayan ürünlerden kaynaklanan sorunların azalması",
      "Tekrarlanan manuel işlemlerin azalması",
      "Ürün takibinin kolaylaşması",
      "Operasyon ekibinin zaman kazanması",
      "Farklı satış kanallarında daha tutarlı bilgi akışı",
    ],
    disclaimer:
      "Entegrasyon kapsamı, Üye İşyerinin kullandığı kasa veya stok sisteminin teknik uygunluğuna göre belirlenir.",
    closingCta: "Sistemimi Kontrol Ettir",
  },
  {
    slug: "urun-ve-menu-yonetimi",
    title: "Ürün ve Menü Yönetimi",
    seoTitle: "Ürün ve Menü Yönetimi | Epersonel",
    seoDescription:
      "Ürün adı, açıklama, kategori, barkod, KDV, gramaj, seçenek ve görsellerinizi pazaryerlerine ve kendi sipariş sisteminize satışa hazır hâle getiriyoruz.",
    short:
      "Ürün adı, açıklama, kategori, barkod, KDV, gramaj, seçenek ve görsellerinizi satışa hazır hâle getiriyoruz.",
    ctaLabel: "Hizmeti İncele",
    heading: "Ürün ve Menü Kataloğunuz Satışa Hazır Hâle Gelsin.",
    intro:
      "Binlerce ürünün pazaryerlerinde ve kendi sipariş sisteminizde tutarlı, arama motoru dostu ve satışa hazır biçimde yayımlanması için gerekli tüm süreçleri sizin adınıza yürütüyoruz.",
    scope: [
      "Ürün adı ve açıklamalarının düzenlenmesi",
      "Kategori, marka, barkod, gramaj ve KDV bilgilerinin hazırlanması",
      "Ürün ve menü görsellerinin düzenlenmesi",
      "Seçenek ve ek ürün gruplarının oluşturulması",
      "Fiyat girişlerinin hazırlanması",
      "Satış kanalına uygun listeleme",
    ],
    closingCta: "Ürün Kataloğumu Hazırlat",
  },
  {
    slug: "dijital-operasyon-yonetimi",
    title: "Dijital Operasyon Yönetimi",
    seoTitle: "Dijital Operasyon Yönetimi | Epersonel",
    seoDescription:
      "Ürün, fiyat, stok, kampanya, sipariş ve mağaza performansı süreçlerinizi düzenli olarak takip eden gerçek bir operasyon ekibi.",
    short:
      "Kampanya, sipariş, iade, fatura ve mağaza performansı süreçlerinizi düzenli olarak takip ediyoruz.",
    ctaLabel: "Operasyon Desteğini İncele",
    heading: "Dijital Satış Operasyonunuz İçeriden Yönetilsin.",
    intro:
      "Epersonel, yalnızca teknik kurulum gerçekleştirmez. Ürün, fiyat, stok, kampanya, sipariş ve mağaza performansı süreçlerinde işyerinizin operasyonuna dâhil olur.",
    scope: [
      "Ürün ve menü yönetimi",
      "Fiyat ve stok takibi",
      "Kampanya planlama ve uygulama",
      "Reklam süreçlerinin takibi",
      "Sipariş operasyonu",
      "İptal ve iade kontrolü",
      "Fatura süreçlerinin takibi",
      "Mağaza performansının incelenmesi",
      "Üye İşyeriyle düzenli iletişim",
      "İhtiyaca göre yeni satış kanallarının planlanması",
    ],
    highlight:
      "Karşınızda yalnızca bir yazılım değil, operasyonunuzu takip eden gerçek bir ekip var.",
    closingCta: "Operasyon Desteği Al",
  },
];

export const HERO_SERVICES_DROPDOWN = [
  { slug: "pazaryeri-kurulum-yonetimi", label: "Pazaryeri Kurulum ve Yönetimi" },
  { slug: "fiyat-ve-stok-entegrasyonu", label: "Fiyat ve Stok Entegrasyonu" },
  {
    slug: "uye-isyerine-ozel-siparis-sistemi",
    label: "İşyerinize Özel Sipariş Sistemi",
  },
  { slug: "kurye-cozumu", label: "Kurye Çözümü" },
  { slug: "dijital-operasyon-yonetimi", label: "Dijital Operasyon Yönetimi" },
];

export const STATS = [
  { value: "30+", label: "Üye İşyeri", desc: "Dijital satış süreçlerinde çözüm sunulan Üye İşyeri" },
  { value: "50+", label: "Mağaza ve Panel", desc: "Kurulum veya operasyon desteği sağlanan satış kanalı" },
  { value: "50.000+", label: "Ürün", desc: "Hazırlanan, düzenlenen veya sisteme yüklenen ürün" },
  { value: "10+", label: "Şehir", desc: "Epersonel çözümlerinin ulaştığı şehir" },
  { value: "2025'ten beri", label: "", desc: "Üye İşyerlerinin dijital operasyonlarının içindeyiz", isStatic: true },
];

export const MARKETPLACES = [
  "Trendyol Go",
  "Trendyol Go – Randevulu",
  "Getir Çarşı",
  "Getir Yemek",
  "Yemeksepeti Mahalle",
  "Yemeksepeti",
  "Migros Yemek",
  "Sektöre uygun diğer pazaryerleri",
];

export const REFERENCES = [
  { name: "Baytar Burger", shape: "horizontal", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/el2fjy46_01-baytar-burger.png" },
  { name: "Boral Market", shape: "horizontal", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/8cp6kal7_02-boral-market.png" },
  { name: "Bronto", shape: "horizontal", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/aq1uvgee_03-bronto.png" },
  { name: "CarrefourSA", shape: "horizontal", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/vz9ahetz_04-carrefoursa.png" },
  { name: "Ekomini", shape: "horizontal", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/ffkrfdmb_05-ekomini.png" },
  { name: "Emek Hipermarketleri", shape: "horizontal", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/wm0tgy5a_06-emek-hipermarketleri.png" },
  { name: "Miras 7 Market", shape: "square", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/b99b4kso_07-miras-7-market.png" },
  { name: "Seç Market", shape: "square", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/fi0orz2s_08-sec-market.png" },
  { name: "Temel Market", shape: "square", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/s2p7eb7u_09-temel-market.png" },
  { name: "Güleryüz Market", shape: "horizontal", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/vu5rfvm0_10-guleryuz-market.png" },
  { name: "Yayla Market", shape: "horizontal", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/pem8m7df_11-yayla-market.png" },
  { name: "Taze Dal Market", shape: "square", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/23fagko1_12-taze-dal-market.png" },
  { name: "Kardeşler Market", shape: "square", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/uaos41a1_13-kardesler-market.png" },
  { name: "Trent Fast Food", shape: "horizontal", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/t5rkbnob_14-trent-fast-food.png" },
  { name: "Keremoğlu Market", shape: "square", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/px1s6e8s_15-keremoglu-market.png" },
  { name: "Deniz Market", shape: "square", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/mmazsloc_16-deniz-market.png" },
  { name: "Mega Sos", shape: "horizontal", src: "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/pfrta27w_17-mega-sos.png" },
];

export const HERO_VISUALS = {
  groceryPhone:
    "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/t4z4yh4o_emek-market-telefon-alisveris-FINAL.png",
  trackingPhone:
    "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/ru796q71_emek-market-telefon-teslimat-FINAL.png",
  notifNewOrder:
    "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/suc0uit4_bildirim-yeni-siparis-FINAL.png",
  notifPayment:
    "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/la7e5iee_bildirim-odeme-tamamlandi-FINAL.png",
  notifCourier:
    "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/uoy59qte_bildirim-kurye-yonlendirildi-FINAL.png",
  notifDelivered:
    "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/2yv8lof5_bildirim-siparis-teslim-edildi-FINAL.png",
  desktopMonitor:
    "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/zg9yunmn_emek-market-masaustu-monitor-FINAL.png",
  deskNotifNewOrder:
    "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/x59kv2d6_panel-bildirim-yeni-siparis-FINAL.png",
  deskNotifCourier:
    "https://customer-assets-0z36b82j.emergentagent.net/job_pazaryeri-demo/artifacts/xhec57r6_panel-bildirim-kurye-teslimata-cikti-FINAL.png",
};

export const WHY_CARDS = [
  { title: "Operasyonun İçindeyiz", copy: "Dışarıdan tavsiye veren değil, sürece dâhil olarak uygulayan bir ekibiz." },
  { title: "Tek Muhatap", copy: "Farklı satış kanalları ve operasyon süreçleri için tek ekipten destek alın." },
  { title: "İşyerinize Özel Planlama", copy: "Ürün yapınıza, bölgenize, hedeflerinize ve satış kanallarınıza göre çözüm oluşturuyoruz." },
  { title: "Gerçek Operasyon Desteği", copy: "Kurulum sonrasında ürün, fiyat, stok, kampanya ve sipariş süreçlerinde yanınızda oluyoruz." },
  { title: "Şeffaf İletişim", copy: "Yapılan işlemleri ve devam eden süreçleri anlaşılır biçimde paylaşıyoruz." },
  { title: "Büyümeye Uygun Yapı", copy: "İhtiyaçlarınız arttıkça yeni satış kanalları ve çözümler sisteme eklenebilir." },
];

export const HOW_STEPS = [
  { n: "01", title: "İşyerinizi Tanıyalım", copy: "Sektörünüzü, ürün yapınızı, mevcut satış kanallarınızı ve ihtiyaçlarınızı analiz edelim." },
  { n: "02", title: "Size Özel Plan Hazırlayalım", copy: "Kullanılacak pazaryerlerini, entegrasyonu, sipariş sistemini ve teslimat ihtiyacını belirleyelim." },
  { n: "03", title: "Kurulumu Tamamlayalım", copy: "Ürünlerinizi, kategorilerinizi, görsellerinizi, fiyatlarınızı ve gerekli sistemleri hazırlayalım." },
  { n: "04", title: "Satışı ve Operasyonu Yönetelim", copy: "Sistemleriniz çalışmaya başladıktan sonra operasyon, kampanya ve güncellemelerde yanınızda olalım." },
];

export const SECTORS = [
  { name: "Marketler", copy: "Binlerce ürünün hazırlanması, fiyat-stok entegrasyonu, pazaryeri yönetimi, web sipariş sistemi, mobil uygulama ve kurye çözümü." },
  { name: "Restoranlar", copy: "Menü kurulumu, seçenek grupları, ürün görselleri, pazaryeri yönetimi, web ve mobil sipariş sistemi ve kurye çözümü." },
  { name: "Kasap ve Şarküteriler", copy: "Ağırlıklı ürün yapısına uygun katalog, fiyatlandırma, sipariş ve teslimat çözümleri." },
  { name: "Manavlar", copy: "Güncel fiyat ve stok takibi gerektiren ürünler için düzenli dijital operasyon." },
  { name: "Petshoplar", copy: "Mama, bakım ürünü ve aksesuar kategorilerinin satış kanallarına uygun biçimde hazırlanması." },
  { name: "Çiçekçiler", copy: "Ürün seçenekleri, özel gün kampanyaları, sipariş yönetimi ve teslimat çözümleri." },
  { name: "Diğer Yerel Satış Noktaları", copy: "Farklı sektörlerdeki Üye İşyerleri için ihtiyaca özel dijital satış çözümleri." },
];

export const FAQS = [
  { q: "Epersonel tam olarak ne yapar?", a: "Epersonel; Üye İşyerlerinin pazaryeri mağazalarını kurar ve yönetir, ürün ve menü süreçlerini hazırlar, fiyat-stok entegrasyonu sağlar, web ve mobil sipariş sistemi oluşturur ve uygun operasyonlarda kurye çözümü sunar." },
  { q: "Hangi sektörlere hizmet veriyorsunuz?", a: "Market, restoran, kasap, şarküteri, manav, petshop, çiçekçi ve farklı sektörlerdeki Üye İşyerlerine hizmet veriyoruz." },
  { q: "Mevcut pazaryeri mağazamızı devralabilir misiniz?", a: "Evet. Mevcut mağazanız incelendikten sonra ürün, fiyat, stok, görsel, kampanya ve günlük operasyon süreçleri için uygun bir çalışma planı hazırlanabilir." },
  { q: "Ürün listemiz hazır değilse ne olur?", a: "Hizmet kapsamına göre ürün listesinin oluşturulması, düzenlenmesi ve pazaryerlerine uygun hâle getirilmesi konusunda destek sağlanabilir." },
  { q: "Web ve mobil sipariş sistemi nasıl çalışır?", a: "Üye İşyerinin adı, logosu, renkleri ve alan adıyla web sipariş sistemi hazırlanır. Ayrıca Üye İşyerinin kendi markasıyla App Store ve Google Play'de yayımlanan ayrı mobil uygulamalar oluşturulur." },
  { q: "Kendi kuryemiz yoksa hizmet alabilir miyiz?", a: "Evet. Operasyonel uygunluğa göre kurye yönlendirmesi yapılabilir. Teslimat bölgesi, mesafe, çalışma saatleri ve ücret Üye İşyerine özel belirlenir." },
  { q: "Pazaryerlerinden gelen siparişler için de kurye çağırabilir miyiz?", a: "Evet. Kurye çözümü yalnızca Epersonel sipariş sisteminde değil, farklı pazaryerlerinden alınan siparişlerde de kullanılabilir." },
  { q: "Fiyat ve stoklar otomatik güncellenebilir mi?", a: "Üye İşyerinin kullandığı kasa veya stok sisteminin teknik uygunluğuna göre fiyat ve stok entegrasyonu kurulabilir." },
  { q: "Hizmet ücretleri nasıl belirleniyor?", a: "Ücretler sektör, ürün sayısı, kullanılacak satış kanalları ve ihtiyaç duyulan çözümlere göre belirlenir. Ücretsiz ön analiz sonrasında Üye İşyerine özel teklif hazırlanır." },
  { q: "Epersonel pazaryerlerinin resmî ortağı mı?", a: "Epersonel pazaryerlerinin resmî ortağı değildir. Üye İşyerleri adına kurulum ve günlük operasyon süreçlerini yöneten bağımsız bir Üye İşyeri operasyon partneridir." },
];

export const FLOATING_STATUS = [
  { text: "Yeni sipariş alındı", tone: "green" },
  { text: "Fiyat ve stok güncellendi", tone: "green" },
  { text: "Kurye yönlendirildi", tone: "green" },
  { text: "Kampanya aktif", tone: "green" },
  { text: "Sipariş teslim edildi", tone: "green" },
];

export const LEGAL_PAGES = [
  { slug: "kvkk", title: "KVKK Aydınlatma Metni" },
  { slug: "gizlilik-politikasi", title: "Gizlilik Politikası" },
  { slug: "cerez-politikasi", title: "Çerez Politikası" },
  { slug: "kullanim-kosullari", title: "Kullanım Koşulları" },
  { slug: "ticari-iletisim-izni", title: "Ticari İletişim İzni" },
];

export const whatsappUrl = () => {
  const msg = encodeURIComponent(BRAND.contact.whatsappMessage);
  return `https://wa.me/${BRAND.contact.phoneRaw}?text=${msg}`;
};
